import script from "./BackToTop.vue?vue&type=script&lang=ts&setup=true"
export * from "./BackToTop.vue?vue&type=script&lang=ts&setup=true"

import "./BackToTop.vue?vue&type=style&index=0&id=1adad1b0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1adad1b0"]])

export default __exports__